import React, { useState, useEffect, useCallback, useRef } from 'react';
import cx from 'classnames';
import { SnackBarContent } from './SnackBarContent';
import styles from './SnackBar.module.css';
// animation duration, see also styles
const DEFAULT_DISPLAY_DURATION = 3000;
const FADE_IN_DURATION = 300;
const FADE_OUT_DURATION = 300;
/**
 * SnackBar component
 *
 * displays content with animation for a fixed time
 */
const SnackBar = ({ className, children, contentClassName, message, textSize, textColor, bold, displayDuration = DEFAULT_DISPLAY_DURATION, closeable, pauseOnHover, onClose, appearance }) => {
    const [visible, setVisible] = useState(true);
    const timer = useRef();
    const close = useCallback(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const hide = useCallback(() => {
        setVisible(false);
        timer.current = setTimeout(close, FADE_OUT_DURATION);
    }, [close]);
    useEffect(() => {
        timer.current = setTimeout(hide, displayDuration + FADE_IN_DURATION);
        return () => clearTimeout(timer.current);
    }, [displayDuration, hide]);
    const onMouseEnter = () => pauseOnHover && timer.current && clearTimeout(timer.current);
    const onMouseLeave = () => pauseOnHover && hide();
    return (React.createElement("div", { className: cx(styles.component, className, {
            [styles.show]: visible,
            [styles.hide]: !visible
        }), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children || (React.createElement(SnackBarContent, { bold: bold, textSize: textSize, textColor: textColor, className: contentClassName, closeable: closeable, onClose: onClose, appearance: appearance }, message))));
};
export default SnackBar;
//# sourceMappingURL=SnackBar.js.map